import React, { useEffect, useState } from "react";

const API = "https://api.galaxylabsnyc.com/api/v1";
const NAME = "Category Header Image";

function collectRecords(value, output = []) {
  if (!value) return output;

  if (Array.isArray(value)) {
    value.forEach(item => {
      if (item && typeof item === "object") {
        output.push(item);
        collectRecords(item, output);
      }
    });

    return output;
  }

  if (typeof value === "object") {
    Object.values(value).forEach(item =>
      collectRecords(item, output)
    );
  }

  return output;
}

export default function CategoryHeaderImageSettings() {
  const [record, setRecord] = useState(null);
  const [image, setImage] = useState(null);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const token = localStorage.getItem("tokenAdmin");

  async function load() {
    try {
      const response = await fetch(
        API + "/User/get-social-links",
        { cache: "no-store" }
      );

      const payload = await response.json();

      const found = collectRecords(payload).find(
        item => item?.name === NAME
      );

      setRecord(found || null);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function save() {
    if (!image) {
      setMessage("Choose an image first.");
      return;
    }

    setSaving(true);
    setMessage("");

    try {
      const form = new FormData();

      form.append("name", NAME);
      form.append("link", "category-header");
      form.append("image", image);

      const url = record?._id
        ? API +
          "/Admin/updateSocialLink/" +
          encodeURIComponent(record._id)
        : API + "/Admin/createSocialLink";

      const response = await fetch(url, {
        method: record?._id ? "PUT" : "POST",
        headers: {
          authorization: "Bearer " + token
        },
        body: form
      });

      const payload = await response.json();

      if (
        !response.ok ||
        payload?.success === false ||
        payload?.status === false
      ) {
        throw new Error(
          payload?.message ||
          "Unable to save Category Header Image."
        );
      }

      setImage(null);

      await load();

      setMessage("Category Header Image updated.");
    } catch (error) {
      setMessage(
        error?.message ||
        "Unable to save Category Header Image."
      );
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="card mb-4">
      <div className="card-body">
        <h4>Category Header Image</h4>

        <p className="text-muted">
          This image appears behind the category title on
          every category page.
        </p>

        {record?.image && (
          <div className="mb-3">
            <img
              src={record.image}
              alt="Current category header"
              style={{
                width: "100%",
                maxWidth: "420px",
                height: "140px",
                objectFit: "cover",
                borderRadius: "10px"
              }}
            />
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          className="form-control mb-3"
          onChange={event =>
            setImage(
              event.target.files?.[0] || null
            )
          }
        />

        <button
          type="button"
          className="btn btn-main"
          disabled={!image || saving}
          onClick={save}
        >
          {saving
            ? "Saving..."
            : "Change Category Header Image"}
        </button>

        {message && (
          <div className="mt-2">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}
